import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import {
    CdsDateField,
    CdsFileUploadField,
    useFormContext,
} from "clayco-component-library";

const PayslipForm = ({ attachment, setAttachment, show }) => {
    const { getValues, setValue, reset } = useFormContext();

    useEffect(() => {
        if (!show) {
            console.log("psfvalues", getValues());
            reset();
            setValue("dateFrom", null);
            setValue("dateTo", null);
            setValue("issuedDate", null);
            setValue("payslip", null);
        }
    }, [show]);

    function getBase64(file) {
        return new Promise((resolve) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                var result = reader.result;
                var idx = result.indexOf(",");
                if (idx >= 0) {
                    resolve({ file: file, data: result.slice(idx + 1) });
                }
                resolve({});
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
            };
        });
    }

    function onFileChanged(evt) {
        if (evt.currentTarget.files.length > 0) {
            var file = evt.currentTarget.files[0];
            getBase64(file).then((response) => {
                setValue("payslip", {
                    data: response.data,
                    file: response.file,
                });
                setAttachment({
                    data: response.data,
                    file: response.file,
                });
            });
        }
    }

    return (
        <>
            <Row className="mb-2">
                <Col>
                    <CdsDateField
                        name="dateFrom"
                        key="dateFrom"
                        id="dateFrom"
                        required={false}
                        label="Pay Period Start Date"
                        showIcon={true}
                        maxDate={new Date()}
                        initialDate={null}
                        placeholder="mm/dd/yyyy"
                        onChange={(value) => setValue("dateFrom", value)}
                    />
                </Col>
            </Row>
            <Row className="mb-2">
                <Col>
                    <CdsDateField
                        name="dateTo"
                        key="dateTo"
                        id="dateTo"
                        required={false}
                        label="Pay Period End Date"
                        showIcon={true}
                        maxDate={new Date()}
                        initialDate={null}
                        placeholder="mm/dd/yyyy"
                        onChange={(value) => setValue("dateTo", value)}
                    />
                </Col>
            </Row>
            <Row className="mb-2">
                <Col>
                    <CdsDateField
                        name="issuedDate"
                        key="issuedDate"
                        id="dissuedDate"
                        required={false}
                        label="Check Date"
                        showIcon={true}
                        initialDate={null}
                        placeholder="mm/dd/yyyy"
                        onChange={(value) => setValue("issuedDate", value)}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <CdsFileUploadField
                        label="Upload Payslip (only .pdf format allowed)"
                        name={`payslip`}
                        key={`payslip`}
                        onChange={(evt) => onFileChanged(evt)}
                    />
                </Col>
            </Row>
        </>
    );
};

export default PayslipForm;
